<template>
  <div class="content content-fixed content-auth-alt">
    <div class="container ht-100p">
      <div v-if="mode == 0"
        class="ht-100p d-flex flex-column align-items-center justify-content-center"
      >
        <div class="wd-150 wd-sm-250 mg-b-30">
          <img src="/assets/svg/complete.svg" class="img-fluid" alt />
        </div>
        <h4 class="tx-20 tx-sm-24">Мэдээлэл шалгах</h4>
        <p class="tx-color-03 mg-b-40">
          Та шалгах сертификатын дугаар болон регистерийн дугаарыг эсвэл бүртгэлтэй и-мэйл хаягийг оруулаад шалгах товчийг дарна уу.
        </p>
        <div class="tx-13 tx-lg-14 mg-b-40 wd-500">
          <div class="mg-b-10">
            <input
              v-model="code"
              maxlength="12"
              type="text"
              class="form-control"
              placeholder="Сертификатын дугаар оруулна уу"
            />
          </div>
          <div class="mg-b-10">
            <input
              v-model="regno"
              type="text"
              class="form-control"
              placeholder="Регистрийн дугаар эсвэл бүртгэлтэй и-мэйл хаяг оруулна уу"
            />
          </div>
          <button v-if="mode==0"
            type="button"
            @click="activate()"
            class="btn btn-primary btn-block text-white "
          >
            Шалгах
          </button>
          <div class="divider-text">Эхлэл рүү буцах</div>
          <button
            type="button"
            @click="renew()"
            class="btn btn-white btn-block"
          >
            Эхлэл
          </button>
          
        </div>
      </div>

      <div v-else-if="mode == 1"
        class="ht-100p d-flex flex-column align-items-center justify-content-center"
      >
        <div class="wd-150 wd-sm-250 mg-b-30">
          <img src="/assets/svg/done.svg" class="img-fluid" alt />
        </div>
        <h4 class="tx-20 text-success tx-sm-24">Сертификат баталгаажсан</h4>
        <p class="tx-color-03 mg-b-40 text-center">
          <b>{{st1}}</b> овогтой <b>{{st2}}</b> нь <b>{{st3}}</b>-ны хооронд <br /><b>{{st4}}</b> сургалтыг дүүргэж <br /><b>{{code}}</b> дугаартай сертификатыг авсан нь үнэн болно.
        </p>
        <div class="tx-13 tx-lg-14 mg-b-40 wd-300 text-center">
          
          
          <button type="button" @click="mode=0"
            class="btn btn-primary d-inline-flex text-white align-items-center mg-l-auto">
            Дахин хайх
          </button>
        </div>
      </div>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";
import { localRead } from "@/libs/util";
import { mapActions } from "vuex";

const moment = require("moment");

export default {
  data() {
    return {
      code: "",
      regno: '',
      mode: 0,
      st1: '',
      st2: '',
      st3: '',
      st4: '',
    };
  },
  methods: {
    ...mapActions(["handleLoading"]),
    activate() {
      this.handleLoading({ isLoading: true });
      
      request({
        api: { method: "POST", url: "v2/learn/CheckCertificate" },
        data: {
          certNo: this.code,
          regNo: this.regno
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          if(res.data!=undefined){
            this.mode=1;
          }
          //console.log('res', res);
          this.st1= res.data.user.lastName;
          this.st2= res.data.user.firstName;
          this.st3= moment(res.data.course.startDate).format("YYYY/MM/DD")+' - '+moment(res.data.course.endDate).format("YYYY/MM/DD");
          this.st4= res.data.course.name;
          //741540
          //АБ11223344
          // Notification.success({
          //   message:
          //     "Таны бүртгэл амжилттай идэвхжлээ. Та нэвтрэх нэр, нууц үгээ оруулна уу. Динамик платформд тавтай морилно уу",
          //   title: "Амжилттай",
          //   duration: 30000,
          //   type: "success",
          //   position: "top-right",
          //   offset: 50
          // });
          //this.$router.push({ name: "login" });
        }
      });
    },
    renew() {
      this.$router.push({name: 'login'})
    }
  }
};
</script>
<style lang="scss" scoped>
  @import "@/assets/scss/pages/auth.scss";
</style>
